export enum MaritalStatus {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  DIVORCED = 'DIVORCED',
  SEPARATED = 'SEPARATED',
  WIDOWER = 'WIDOWER',
}
